/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SerievideoSeriesSerieidQueryResponse,
  GetApiV1SerievideoSeriesSerieidPathParams,
  GetApiV1SerievideoSeriesSerieidQueryParams,
  GetApiV1SerievideoSeriesSerieid401,
  GetApiV1SerievideoSeriesSerieid404,
  GetApiV1SerievideoSeriesSerieid500,
} from "../../types/serieVideoRegistroController/GetApiV1SerievideoSeriesSerieid.ts";

function getGetApiV1SerievideoSeriesSerieidUrl(
  serieId: GetApiV1SerievideoSeriesSerieidPathParams["serieId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/serievideo/series/${serieId}` as const,
  };
  return res;
}

/**
 * @description Retorna uma lista paginada de vídeos de uma série (informe o serieId na rota). Filtra por título. **(Requer Authorization para autenticação)**
 * @summary Listar vídeos da série (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/series/:serieId}
 */
export async function getApiV1SerievideoSeriesSerieid(
  serieId: GetApiV1SerievideoSeriesSerieidPathParams["serieId"],
  params?: GetApiV1SerievideoSeriesSerieidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SerievideoSeriesSerieidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerievideoSeriesSerieid401
      | GetApiV1SerievideoSeriesSerieid404
      | GetApiV1SerievideoSeriesSerieid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SerievideoSeriesSerieidUrl(serieId).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
